import React from "react";
import { createBugReport } from "../../firebase/userhelp/reportbugs/create";
import { fetchReportBugs } from "../../firebase/userhelp/reportbugs/get";
import UserHelpModal from "./comp/UserHelpModal";

const ReportBug = ({ modalVisible, setModalVisible }) => {
  const handleSubmit = async (data) => {
    await createBugReport(data);
    // Refresh the bugs list for admin pages
    fetchReportBugs();
  };

  return (
    <UserHelpModal
      modalVisible={modalVisible}
      setModalVisible={setModalVisible}
      type="bug"
      onSubmit={handleSubmit}
      showFileUpload={true}
    />
  );
};

export default ReportBug;
